export interface IMarketplaceSimpleBundleInfo {
    bundleId: string;
    bundleName: string;
}
